"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _aspectRatioHeights = _interopRequireDefault(require("../../constants/aspectRatioHeights"));

var ASPECT_RATIOS = Object.keys(_aspectRatioHeights.default);

var AspectRatioSelector = function AspectRatioSelector(_ref) {
  var aspectRatio = _ref.aspectRatio,
      handleStoryboardFieldChange = _ref.handleStoryboardFieldChange;
  return _react.default.createElement("div", {
    className: "shot-list__aspect-ratio-wrapper column-right"
  }, _react.default.createElement("p", null, "Aspect Ratio"), _react.default.createElement(_uiKit.Dropdown, {
    className: "details__panel__input",
    type: "BASIC",
    onChange: handleStoryboardFieldChange('aspectRatio'),
    defaultValue: aspectRatio,
    options: ASPECT_RATIOS
  }));
};

var _default = AspectRatioSelector;
exports.default = _default;